/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-30 17:15:02
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-07 10:44:06
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\config\routes\ai-legal.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  // 场景体验
  {
    path: '/ai-legal/chat',
    name: 'ai-legal-chat',
    component: () => import('@/views/ai-legal/chat/index.vue'),
    meta: {
      title: '智能对话',
      isHeaderMenu: true,
    },
  },
  {
    path: '/ai-legal/generate-docs',
    name: 'ai-legal-generate-docs',
    component: () => import('@/views/ai-legal/generate-docs/index.vue'),
    meta: {
      title: '文书生成',
      isHeaderMenu: true,
    },
  },
];
